import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { TextField, Grid } from '@material-ui/core';

function FormInput({ name, label }) {
  const { control } = useFormContext();
  const isError = false;

  return (
    <Grid item xs={12} sm={6}>
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, onBlur, value, name, ref } }) => (
          <TextField
            onBlur={onBlur}
            onChange={onChange}
            checked={value}
            inputRef={ref}
            name={name}
            label={label}
            fullWidth
            required
            name={name}
          />
        )}
      />
    </Grid>
  );
}
console.log(FormInput);
export default FormInput;
